module.exports = __webpack_public_path__ + "img/2.fc74b059.jpg";